import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listService } from '@/services/listService';
import { CreateListRequest } from '@/types/list';
import { useToast } from '@/hooks/use-toast';

export const useLists = () => {
  return useQuery({
    queryKey: ['lists'],
    queryFn: listService.getLists,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useCreateList = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (request: CreateListRequest) => listService.createList(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lists'] });
      toast({
        title: "Success",
        description: "List created successfully",
      });
    },
    onError: (error) => {
      console.error('Error creating list:', error);
      toast({
        title: "Error",
        description: "Failed to create list. Please try again.",
        variant: "destructive",
      });
    },
  });
};
